// extracted by mini-css-extract-plugin
export default {"add":"RegulationsModal_add__OB+2W"};